











































import {
  AdgroupFormData,
  BehaviorHashtagKeywordSearchInfo,
  BehaviorTag,
  TargetingKeywordsType,
} from '@tt4b/ttam-enums';
import {
  StateEnum,
  useBehaviorHashTagsInfoApi,
  useRequest,
  useSearchBehaviorHashTagsApi,
  useStore,
} from '@tt4b/ttam-hooks';
import { computed, defineComponent, toRefs, ref, watch, PropType, onMounted } from '@vue/composition-api';
import { i18n } from './../../../../i18n';
import { debounce } from 'lodash-es';
import { trackEvent } from './../../../../utils/index';
import { useHashtagBehaviorTracer } from '../use-hashtag-behavior-tracer';
import treeNodeHoverEstimate from '@/components/common/tree-node-hover-estimate/index.vue';

const name = 'ttam-behavior-hashtag-category';
export default defineComponent({
  name,
  components: {
    treeNodeHoverEstimate,
  },
  model: {
    prop: 'selectedCategory',
    event: 'change',
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },
    selectedCategory: {
      type: Array as PropType<Array<number>>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { selectedCategory, adgroupData } = toRefs(props);
    const adgroupId = computed(() => adgroupData.value?.adId || '');
    const _selectedCategory = computed({
      get: () => selectedCategory.value,
      set: val => {
        emit('change', val);
      },
    });
    const keyword = ref('');
    const searchResult = ref<(BehaviorTag & BehaviorHashtagKeywordSearchInfo)[]>([]);
    const { state } = useStore();
    const hashtagBehaviorMap = computed(() => state[StateEnum.targetInfo].value.hashtagBehaviorMap);
    const { run: search } = useRequest(useSearchBehaviorHashTagsApi, null, {
      manual: true,
    });
    const { run: loadInfo } = useRequest(useBehaviorHashTagsInfoApi, null, {
      manual: true,
    });
    const hashtagsTree = computed(() => {
      const tree: (BehaviorTag & { visible: boolean })[] = [];
      const searchResultIdsSet = new Set();
      searchResult.value.forEach(item => {
        searchResultIdsSet.add(item.id);
        tree.push({ ...item, visible: true });
      });
      hashtagBehaviorMap.value.forEach(ele => {
        const { id } = ele;
        if (!searchResultIdsSet.has(Number(id))) {
          tree.push({ ...(ele as any), hide: true, visible: false });
        }
      });
      return tree;
    });

    function handleQueryResult(data: { keywords: (BehaviorTag & BehaviorHashtagKeywordSearchInfo)[] }) {
      let keywords = data.keywords ?? [];
      keywords = keywords.map(item => {
        let label = item.name || '';
        const description =
          item.typeEnum === TargetingKeywordsType.HASHTAG
            ? i18n.t('adgroup_target_hashtag_audience_estimate', {
                hashtag: label,
              })
            : i18n.t('adgroup_target_hashtag_audience_hashtaggroup', {
                hashtag: label,
              });
        if (item.typeEnum === TargetingKeywordsType.HASHTAG_GROUP) {
          label = i18n.t('adgroup_target_hashtag_search_hashtaggroup', {
            name: label,
          }) as string;
        }
        const newItem = {
          ...item,
          label,
          translation: label,
          description,
          id: Number(item.id),
        };
        if (!hashtagBehaviorMap.value.find(tag => tag.id === newItem.id)) {
          state[StateEnum.targetInfo].value.hashtagBehaviorMap.push({ ...newItem });
        }
        return newItem;
      });
      return keywords;
    }

    const searchTea3S = debounce(function searchTeaHandle() {
      trackEvent('create_campaign_targeting_behavior_searchresult_impression', {
        keyword: keyword.value,
        number: searchResult.value.length,
        adgroup_id: adgroupId.value,
      });
    }, 3000);

    const searchHashtags = debounce(
      async function searchHashtags() {
        const keywordToSearch = keyword.value;
        if (!keywordToSearch) {
          searchResult.value = [];

          return;
        }

        const data = await search(keyword.value);
        if (keywordToSearch !== keyword.value || !data) {
          return;
        }
        searchResult.value = handleQueryResult(data);
      },
      300,
      { leading: true, trailing: true, maxWait: 500 },
    );

    const loadHashtagsInfo = async () => {
      if (selectedCategory.value.length) {
        const data = await loadInfo(selectedCategory.value.map(id => ({ id })));
        handleQueryResult(data);
      } else {
        state[StateEnum.targetInfo].value.hashtagBehaviorMap = [];
      }
    };

    function filterHashtagSearchResult() {
      return (_keyword, node) => !node.hide;
    }

    const treeNodeHoverEstimateRef = ref();
    function onMouseEnterNode(node) {
      trackEvent('create_campaign_targeting_behavior_searchresult_impression', {
        keyword: keyword.value,
        number: searchResult.value.length,
        adgroup_id: adgroupId.value,
      });
      const hoverNodeData = node?.data ?? {};
      treeNodeHoverEstimateRef.value?.showHoverEstimate(hoverNodeData);
    }

    onMounted(() => {
      loadHashtagsInfo();
    });

    watch(keyword, (value, oldValue) => {
      searchTea3S();
      // 点击X埋点
      if (value === '' && oldValue.length > 0) {
        if (searchResult.value.length === 0 && oldValue.length >= 3) {
          trackEvent('create_campaign_targeting_behavior_searchmiss_empty', {
            keyword: oldValue,
            adgroup_id: adgroupId.value,
          });
        }
        trackEvent('create_campaign_targeting_behavior_searchbox_cross_click', {
          number: searchResult.value.length,
          adgroup_id: adgroupId.value,
        });
      }
      searchHashtags();
    });

    watch(_selectedCategory, (value, oldValue) => {
      if (value?.length > oldValue?.length) {
        trackEvent('create_campaign_targeting_interest_searchresult_click', {
          adgroup_id: adgroupId.value,
        });
      }
    });

    const {
      afterClickResultListItem,

      onShowSearchResultList,
      onHideSearchResultList,

      onSelectTreeInteraction,
      onHoverResultListItem,
      onExposeResultListItem,
    } = useHashtagBehaviorTracer(keyword, searchResult);

    return {
      name,
      adgroupId,
      _selectedCategory,
      keyword,
      hashtagsTree,
      searchResult,
      treeNodeHoverEstimateRef,
      filterHashtagSearchResult,
      onMouseEnterNode,

      afterClickResultListItem,

      onShowSearchResultList,
      onHideSearchResultList,

      onSelectTreeInteraction,
      onHoverResultListItem,
      onExposeResultListItem,
    };
  },
});
